// Heavy-Mineral-Sands (HMS) commodity gating - mirrors backend processing.is_hms_commodity.
// The HMS Geomorphology suite is only active for heavy-mineral-sands commodities; for all other
// mineral types (Gold, Copper, Iron Ore, ...) it is hidden to keep a clean, professional UX.
export const HMS_MINERALS = new Set([
  "ilmenite", "rutile", "zircon", "monazite", "leucoxene",
  "titanium", "heavy mineral sands", "mineral sands", "hms", "thm",
]);

export const isHmsCommodity = (name) =>
  !!name && HMS_MINERALS.has(String(name).trim().toLowerCase());

const mineralNames = (m) => {
  if (!m) return [];
  if (Array.isArray(m)) return m.map((x) => (typeof x === "string" ? x : (x?.name || x?.mineral || "")));
  if (typeof m === "object") return Object.keys(m);
  return [];
};

export const areaIsHms = (area, project) =>
  isHmsCommodity(area?.commodity) ||
  isHmsCommodity(project?.commodity) ||
  mineralNames(area?.minerals).some(isHmsCommodity);

export const projectIsHms = (project) =>
  isHmsCommodity(project?.commodity) ||
  (project?.areas || []).some((a) => areaIsHms(a, project));
